var $ = require('../../modules/$');
module.exports = function create(P, D){
  return $.create(P, D);
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/object/create.js
// module id = 853
// module chunks = 0